export default {
    theme: {
        fontFamily: {
            sans: ['Lato', 'sans-serif'],
        },
        extend: {
            colors: {
                primary: {
                    DEFAULT: '#447bbe',
                },
                secondary: {
                    DEFAULT: '#55d6be',
                },
                tertiary: {
                    DEFAULT: '#34b4f5',
                    50: '#293f4d',
                    100: '#59c2ef',
                    200: '#18b2e1',
                },
                light: '#f8f9fa',
                body: { DEFAULT: '#495057' },
                gray: {
                    DEFAULT: '#efefef',
                    50: '#f8f9fa',
                    800: '#343a40',
                },
                yellow: {
                    DEFAULT: '#ffc107',
                },
                stars: {
                    900: '#EDBD40',
                    0: '#AEBFD1',
                },
                error: {
                    DEFAULT: '#FF3738',
                },
                warning: {
                    DEFAULT: '#ffc107',
                },
                btn: {
                    DEFAULT: '#e62571',
                    border: '#e93f82',
                    hover: '#cd185f',
                    borderHover: '#b41658',
                    secondary: '#55d6be',
                    secondaryHover: '#3bada4',
                },
                dark: {
                    DEFAULT: '#424652',
                },
                grayDark: {
                    DEFAULT: '#444444',
                },
                brand: {
                    muted: '#b1c7e5',
                    'muted-light': '#e6eef8',
                },
                link: {
                    DEFAULT: '#59c2ef',
                },
            },
        },
    },
};
